import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface PersonalInfoErrors {
  firstName?: string
  lastName?: string
  position?: string
  company?: string
}

const PersonalInfoPage = ({ updateUserData }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    position: '',
    company: '',
  })
  const [errors, setErrors] = useState<PersonalInfoErrors>({})
  const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    const newErrors: PersonalInfoErrors = {}

    if (!formData.firstName.trim()) {
      newErrors.firstName = 'Пожалуйста, введите имя'
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Пожалуйста, введите фамилию'
    }

    if (!formData.position.trim()) {
      newErrors.position = 'Пожалуйста, введите должность'
    }

    if (!formData.company.trim()) {
      newErrors.company = 'Пожалуйста, введите название компании'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {
      updateUserData('personalInfo', formData)
      navigate('/birth-details')
    }
  }

  return (
    <div className="container">
      <div className="header">
        <div className="logo">
          Business <span>Evolution AI</span>
        </div>
      </div>

      <div className="progress-bar">
        <div className="progress-bar-inner" style={{ width: '25%' }}></div>
      </div>

      <h2>Личная информация</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="firstName">Имя:</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Введите ваше имя"
          />
          {errors.firstName && <div className="error">{errors.firstName}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="lastName">Фамилия:</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Введите вашу фамилию"
          />
          {errors.lastName && <div className="error">{errors.lastName}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="position">Текущая должность:</label>
          <input
            type="text"
            id="position"
            name="position"
            value={formData.position}
            onChange={handleChange}
            placeholder="Введите вашу текущую должность"
          />
          {errors.position && <div className="error">{errors.position}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="company">Название компании:</label>
          <input
            type="text"
            id="company"
            name="company"
            value={formData.company}
            onChange={handleChange}
            placeholder="Введите название вашей компании"
          />
          {errors.company && <div className="error">{errors.company}</div>}
        </div>

        <button type="submit" className="btn">
          Продолжить
        </button>
      </form>
    </div>
  )
}

export default PersonalInfoPage
